import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Page, Breadcrumb, Crumb } from '@framework'
import { RebateReportTable } from '@components/Tables'

class RebateOverviewPage extends Component {
  render () {
    return (
      <Page fluid paperWhite className='scope-user-overview'>
        <Helmet title='OPS Admin: User Overview' />
        <Breadcrumb>
          <Crumb to='/manage/workspace'>Home</Crumb>
          <Crumb>Rebate Report</Crumb>
        </Breadcrumb>
        <RebateReportTable/>
      </Page>
    )
  }
}

export default RebateOverviewPage
